export const LAZY_FRAME_FAILURE_MESSAGE = "Couldn't load this section. Reload the page to try again."
export const LAZY_FRAME_FAILURE_CLASS = "text-alert-red-600"

// Turbo leaves a lazy frame's placeholder untouched when its request fails or
// times out, so the panel would otherwise sit on "Loading..." forever.
export function showLazyFrameFailure(statusElement) {
  if (!statusElement) return false

  statusElement.textContent = LAZY_FRAME_FAILURE_MESSAGE
  statusElement.classList.add(LAZY_FRAME_FAILURE_CLASS)
  return true
}
